var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prep-adherence',[_c('p',[_vm._v(" It’s good that you’re being honest. Let’s face, it’s tough to commit to something so regularly. Here a couple of tidbits that can help you. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }